import { createContext as t } from "react";
var o = /* @__PURE__ */ ((e) => (e.light = "light", e.dark = "dark", e.auto = "auto", e))(o || {});
const n = t({
  theme: "auto",
  onThemeChange: () => {
    throw new Error("onThemeChange should be used inside ThemeProvider");
  }
});
export {
  o as Theme,
  n as ThemeContext
};
